/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'confluence.error.panel.refresh.app': 'Uppdatera appen',
  'confluence.error.panel.reload.page': 'Uppdatera sida',
  'confluence.icon.label': 'Ikon',
  'confluence.modal.dialog.close.modal.button': 'Avbryt',
  'confluence.select.required.field.message': 'Fältet är obligatoriskt.',
  'confluence.text.area.required.field.message': 'Fältet är obligatoriskt.',
  'confluence.textfield.validator.email': 'Ange en giltig e-postadress.',
  'confluence.textfield.validator.number': 'Ange ett giltigt nummer',
  'confluence.textfield.validator.required.field.message': 'Fältet är obligatoriskt.',
  'confluence.textfield.validator.telephone': 'Ange ett giltigt telefonnummer.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Åtkomst krävs',
  'confluence.threeLOPrompt.modal.error.title': 'Fel',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'URL för samtycke hittades inte. Uppdatera sidan och försök igen.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'URL för samtycke hittades inte. Uppdatera sidan och försök igen.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Tillåt åtkomst',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Konfigurera åtkomst',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Det gick inte att autentisera.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'För att {appString} ska visas måste du ge appen åtkomst till Atlassian-produkter för din räkning.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} kräver ytterligare åtkomst till ditt konto.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Extern aut.varning',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'den här appen',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Den här appen',
  'confluence.user.group.unknown.user.message': 'Okänd användare',
  'confluence.user.picker.empty.field.error.message': 'Fältet är obligatoriskt.',
  'confluence.user.unknown.user.message': 'Okänd användare',
  'forge-ui.form.submit-button.text': 'Skicka in',
};
